// extracted by mini-css-extract-plugin
export default {"fields":"MqDyXD","mobile":"QHz4mL"};